// extracted by mini-css-extract-plugin
export default {"main_container":"SectionLayout_main_container__wIn67","section_layout":"SectionLayout_section_layout__9D8XN"};